import { SERVICE_TYPES } from "../shared/tagTypes";
import { baseApi } from "./base";

const serviceTypeApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [SERVICE_TYPES],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getServiceTypes: builder.query({
                query: (payload) => ({
                    url: payload.companyId ? `/serial-no/companies/${payload.companyId}/service-types` : `/serial-no/service-centers/${payload.serviceCenterId}/service-types`
                }),
                providesTags: [SERVICE_TYPES],
            }),
            getServiceType: builder.query({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-types/${payload.id}`
                }),
                providesTags: [SERVICE_TYPES],
            }),
            createServiceType: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-types`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [SERVICE_TYPES],
            }),
            updateServiceType: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-types/${payload.id}`,
                    method: "PUT",
                    body: payload.body,
                }),
                invalidatesTags: [SERVICE_TYPES],
            }),
            deleteServiceType: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/companies/${payload.companyId}/service-types/${payload.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: [SERVICE_TYPES],
            }),
            getServiceCenterServiceTypes: builder.query({
                query: (payload) => ({
                    url: `/serial-no/service-centers/${payload.serviceCenterId}/service-types`,
                    params: {
                        ...(payload.defaultIfNotSet && { defaultIfNotSet: payload.defaultIfNotSet })
                    }
                }),
                providesTags: [SERVICE_TYPES],
            }),
            createServiceCenterServiceType: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/service-centers/${payload.serviceCenterId}/service-types`,
                    method: "POST",
                    body: payload.body,
                }),
                invalidatesTags: [SERVICE_TYPES],
            }),
            updateServiceCenterServiceType: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/service-centers/${payload.serviceCenterId}/service-types`,
                    method: "PUT",
                    body: payload.body,
                }),
                invalidatesTags: [SERVICE_TYPES],
            }),
            deleteServiceCenterServiceType: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/service-centers/${payload.serviceCenterId}/service-types/${payload.id}`,
                    method: "DELETE",
                }),
                invalidatesTags: [SERVICE_TYPES],
            })
        }),

        overrideExisting: false,
    });

export const {
    useGetServiceTypesQuery,
    useLazyGetServiceTypesQuery,
    useGetServiceTypeQuery,
    useLazyGetServiceTypeQuery,
    useCreateServiceTypeMutation,
    useUpdateServiceTypeMutation,
    useDeleteServiceTypeMutation,
    useGetServiceCenterServiceTypesQuery,
    useLazyGetServiceCenterServiceTypesQuery,
    useCreateServiceCenterServiceTypeMutation,
    useUpdateServiceCenterServiceTypeMutation,
    useDeleteServiceCenterServiceTypeMutation
} = serviceTypeApi;
